import React, { Component } from 'react';

class HelpMessages extends Component {
  render() {
    return <div></div>;
  }
}

export function describeHowYouGotCompetences2(lng) {
  if (lng === 'si') {
    return '(Neobvezno) Povejte kako ste pridobili vaše izkušnje in kompetence. Dodate lahko tudi povezave do raznih projektov, na katerih ste delali v preteklosti...';
  } else {
    return '(Optional) Tell us how you acquired experiences. You can also provide links to projects that you have worked on...';
  }
}

//#region DASHBOARD
export function getDashboardDescriptionText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h3>
          <small>
            Nadzorna plošča omogoča pregled in dostop do podatkov. Do podatkov je z nadzorne plošče možno dostopati
            preko bližnjic in s filtriranjem.
          </small>
        </h3>
        <h4>Glavne funkcionalnosti:</h4>
        <ul>
          <li>
            Bližnjica do Kandidatov z opcijo filtriranja (v vnosno polje vpišite ime ali del imena in pritisnite Enter)
          </li>
          <li>Bližnjica do nastavitev</li>
          <li>Bližnjica do zadnjih kometarjev</li>
          <li>Bližnjica z možnostjo filtriranja do zadnjih kandidatov</li>
          <li>Bližnjica z možnostjo filtriranja do zadnjih delovnih mest</li>
          <li>Bližnjica z možnostjo filtriranja do zadnjih kompetenc</li>
        </ul>
      </div>
    );
  } else {
    return (
      <div>
        <h3>
          <small>Dashboard provides overview and shortcuts with filtering to main application functionalities.</small>
        </h3>
        <h4>Main functionalities:</h4>
        <ul>
          <li>Shortcut to company settings</li>
          <li>Shortcut to latest Comments</li>
          <li>Shortcut with filtering to latest Applicants (type name or last name and press Enter)</li>
          <li>Shortcut with filtering to latest Applications</li>
          <li>Shortcut with filtering to latest Jobs</li>
          <li>Shortcut with filtering to latest Competence</li>
        </ul>
      </div>
    );
  }
}
//#endregion

//#region SETTINGS
export function getSettingsDescriptionText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h3>
          <small>
            Tukaj lahko urejate svoje uporabniške nastavitve, ter nastavitve podjetja. Nekateri podatki bodo vidni
            kandidatom, ki se prijavljajo na delovna mesta. Nastavitve se delijo na dva glavna sklopa:
          </small>
        </h3>
        <h4>Uporabniške nastavitve:</h4>
        <ul>
          <li>
            <b>Profil:</b> ime, priimek, ter email. Na ta email boste prejemali obvestila o dogajanju na portalu.
          </li>
          <li>
            <b>Spremeni geslo</b>
          </li>
          <li>
            <b>Obvestila:</b> označite katera obvestila želite prejemati na email.
          </li>
        </ul>
        <h4>Nastavitve podjetja:</h4>
        <ul>
          <li>
            <b>Profil:</b> tukaj vnesite podatki o podjetju. Ti podatki bodo vidni kandidatom, ki iščejo delovna mesta.
            Zato je priporočljivo čim lepše opisati podjetje in s tem prepričati kandidate, da se prijavijo ravno na
            vaše delovno mesto.
          </li>
          <li>
            <b>Uporabniki (Rekrutorji):</b> dojajanje in urejanje novih oporabnikov/rekrutorjev.
          </li>
        </ul>
      </div>
    );
  } else {
    return (
      <div>
        <h3>
          <small>
            Here you can manage your personal and company settings. Some of the data will be visible to the candidates.
            Settings are devided to two main branches:
          </small>
        </h3>
        <h4>User settings:</h4>
        <ul>
          <li>
            <b>Profile:</b> first name, last name and email. To this email you will receive enents from this portal (eg.
            new candidate has applied to a job).
          </li>
          <li>
            <b>Change Password</b>
          </li>
          <li>
            <b>Notifications:</b> select which notifications do you want to receive to your email address.
          </li>
        </ul>
        <h4>Company settings:</h4>
        <ul>
          <li>
            <b>Profile:</b> add your company info here. This data will be visible to your job candidates. Describe your
            company in a positive way and provide benefits of your company. Convince job seekers to apply to the jobs
            from your company!
          </li>
          <li>
            <b>Users (Recruiters):</b> add and manage new users/recruiters.
          </li>
        </ul>
      </div>
    );
  }
}

export function getCompanyBenefitsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Povejte kandidatom vse o prednostih vašega podjetja. Je možen fleksibilen delovni urnik? Delo od doma? Super
        pisarne? Možnost nadaljnega izobraževanja? Letni proračun za izobraževanje? ... Karkoli je, je pomembno!
      </div>
    );
  } else {
    return (
      <div>
        Make sure to tell candidates about your best company benefits. Do you offer flexible work schedules? Remote
        work? Great offices? Possibility of further education? Yearly learning budget? Any other benefits and perks?
        Whatever it is, it matters!
      </div>
    );
  }
}
//#endregion

//#region APPLICANTS
export function getApplicantsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Kandidati so deljeni na dva tipa: <b>ODPRT</b> ali <b>VEZAN</b>. Tip si izbere kandidat sam, ob prijavi na
        delovno mesto.
      </div>
    );
  } else {
    return (
      <div>
        Applicant types are divided by types: <b>OPEN</b> or <b>BOUNDED</b>. Type is defined by Applicant when he or she
        is applying for a Job.
      </div>
    );
  }
}

export function getOpenApplicantsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>ODPRT:</b> Kandidati, ki se zanimajo tudi za podobne službe. Sistem bo samodejno generiral prijavnice, ko se
        pojavijo službe s podobnimi kompetencami.
      </div>
    );
  } else {
    return (
      <div>
        <b>OPEN:</b> Applicants which are available for all <b>OPEN</b> jobs, not only for the specific one.
      </div>
    );
  }
}

export function getBoundedApplicantsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>VEZAN:</b> Kandidati, ki jih zanima samo specifično delovno mesto. Sistem za njih nebo iskal drugih, podobnih
        delovnih mest.
      </div>
    );
  } else {
    return (
      <div>
        <b>BOUNDED:</b> Applicants which are available only for the specific Job for which they had applied. Jobs are
        also divided by type of <b>OPEN</b> or <b>BOUNDED.</b>
      </div>
    );
  }
}

export function getApplicantsTitleText(lng) {
  if (lng === 'si') {
    return <div>Obstajata dva tipa kandidatov</div>;
  } else {
    return <div>There are two types of Applicants</div>;
  }
}

export function getApplicantsQuestion1(lng) {
  if (lng === 'si') {
    return <span>Kje lahko najdem kandidatov življenjepis?</span>;
  } else {
    return <span>Where can I find CV of the Applicant?</span>;
  }
}

export function getApplicantsAnswer1(lng) {
  if (lng === 'si') {
    return (
      <p>
        Kandidatov življenjepis se nahaja znotraj prijavnice. Vsak kandidat se lahko prijavi na več delovnih mest in pod
        vsako prijavnico se nahaja življenjepis.
      </p>
    );
  } else {
    return (
      <p>
        CV of the Applicant is attached under a specific Application. Each Applicant can apply to multiple Jobs and
        every Application has Attached its own CW.
      </p>
    );
  }
}

export function getApplicantsQuestion2(lng) {
  if (lng === 'si') {
    return <span>Kako lahko upravljam s kandidati?</span>;
  } else {
    return <span>How can I manage Applicants?</span>;
  }
}

export function getApplicantsAnswer2(lng) {
  if (lng === 'si') {
    return (
      <p>
        Kandidatom lahko določamo statuse in jih izbrišemo, ko jih ne potrebujemo več. Kandidate lahko tudi filtriramo
        po raznih parametrih. Ko je nov kandidat vnešen v sistem, se mu status samodejno postavi v <i>Nov</i>.
      </p>
    );
  } else {
    return (
      <p>
        You can manage Applicants by setting statuses to them. When Applicant is created, his default status is set to{' '}
        <i>New.</i> You can also delete (and restore) Candidates, when they are proccessed.
      </p>
    );
  }
}

export function getApplicantsQuestion3(lng) {
  if (lng === 'si') {
    return <span>Kako oz. iz kje se pojavijo kandidati v programu?</span>;
  } else {
    return <span>Where do Applicants come from?</span>;
  }
}

export function getApplicantsAnswer3(lng) {
  if (lng === 'si') {
    return (
      <p>
        Kandidati se generirajo ob prijavah na delovna mesta. Lahko jih ustvarjamo tudi sami:{' '}
        <b>
          <ul>
            <li>
              <i>Meni -> Vnesi kandidata</i>
            </li>
            <li>
              <i>Meni -> Kandidati -> Poišči najbolj primerna delovna mesta za kandidata</i>
            </li>
            <li>
              <i>Meni -> Delovna mesta -> Poišči najbolj primerne kandidate za to delovno mesto</i>
            </li>
          </ul>
        </b>
      </p>
    );
  } else {
    return (
      <p>
        Applicants are generated when candidates apply for a Job. They can also be inserted manually:{' '}
        <b>
          <ul>
            <li>
              <i>Menu -> Insert Applicant</i>
            </li>
            <li>
              <i>Menu -> Applicants -> Find most suitable Jobs for thih Applicant</i>
            </li>
            <li>
              <i>Menu -> Jobs -> Find most suitable Candidates for thih Job</i>
            </li>
          </ul>
        </b>
      </p>
    );
  }
}

export function getApplicantsQuestion4(lng) {
  if (lng === 'si') {
    return <span>Ali lahko sam vnašam kandidate?</span>;
  } else {
    return <span>Can I create Applicants manually?</span>;
  }
}

export function getApplicantsAnswer4(lng) {
  if (lng === 'si') {
    return (
      <p>
        Da. Vnesete ga lahko s klikom na:{' '}
        <b>
          <i>Meni -> Vnesi kandidata</i>
        </b>
      </p>
    );
  } else {
    return (
      <p>
        Yes. Start process from:{' '}
        <b>
          <i>Menu -> Insert Applicant</i>
        </b>
      </p>
    );
  }
}
//#endregion

//#region APPLICATIONS
export function getApplicationsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>Prijavnice</b> se delijo glede na tip nastanka. Iz tipa prijavnice lahko ugotovite na kakšen način je
        prijavnica nastala.
      </div>
    );
  } else {
    return (
      <div>
        <b>Applications</b> contain information about Applicant's competences, skills, etc. Our system also evaluates
        and ranks Applications based on the competences provided by the Applicants. Every time when Applicant applies
        for a Job, the system will evaluate him/her and rank him against other Applicants. The system will also evaluate
        him(if he is of type <b>Open</b>), against all other suitable jobs in database.
      </div>
    );
  }
}

export function getJobAutomaticApplicationsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>V1:</b> Samodejno ustvarjene prijavnice preko <b>iskanja najprimernejšega kandidata za specično službo.</b>{' '}
        (Delovna mesta -> Pošči najbolj primerne kandidate za to delovno mesto)
      </div>
    );
  } else {
    return (
      <div>
        <b>Job automatic:</b> Applications generated automatically with searching for{' '}
        <b>most suitable Applicants for a specific Job.</b>
        (Jobs -> Find most suitable candidates for this Job)
      </div>
    );
  }
}

export function getApplicantAutomaticApplicationsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>V2:</b> Prijavnice, ustvarjene samodejno{' '}
        <b>z iskanjem najbolj primernih delovnih mest za specifičnega kandidata.</b>
      </div>
    );
  } else {
    return (
      <div>
        <b>Applicant automatic:</b> Applications generated automatically with searching for{' '}
        <b>most suitable Jobs for a specific Applicant</b> (from the menu on the left side: Applicants -> Find most
        suitable Jobs for this applicant).
      </div>
    );
  }
}
export function getFromCompetencesApplicationsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>V3:</b> Ustvarjene preko postopka v meniju: "Vnesi kandidata".
      </div>
    );
  } else {
    return (
      <div>
        <b>From Competences:</b> composed of competences from procedure "Insert Applicant". This type of Application is
        not bounded to any Job, but it is useful when we are searching for most suitable candidates for a specific Job.
      </div>
    );
  }
}

export function getNormalApplicationsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>OBIČAJNE: </b>ustvarjene ob prijavi kandidatov na delovno mesto.
      </div>
    );
  } else {
    return (
      <div>
        <b>Normal: </b>generated manually by Applicant through application wizard.
      </div>
    );
  }
}

export function getApplicationsFromCompetencesText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>V3: Preko kompetenc: </b>ustvarjene s postopkom "Meni -> Vnesi kandidata".
      </div>
    );
  } else {
    return (
      <div>
        <b>From Competences: </b>generated with wizard "Insert applicant", not bounded to any job.
      </div>
    );
  }
}

export function getApplicationsTitleText(lng) {
  if (lng === 'si') {
    return <div>Obstajajo 4 tipi prijavnic, delijo se glede na način nastanka</div>;
  } else {
    return <div>There are four types of Applications, they are divided by the type of creation</div>;
  }
}

export function getCantCalculateScoreText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Neznano število točk. Možen vzrok: delovno mesto <b>nima dodanih kompetenc</b> ali je pa je tipa <b>V3.</b>
      </div>
    );
  } else {
    return (
      <div>
        Score from competences can not be calculated. Possible reasons: <b>no competences added to a Job</b> or job type
        is <b>From Competences</b>
      </div>
    );
  }
}

// export function chooseOpenOrBoundedApplicationText() {
//   return (
//     <p>
//       Please choose whether your application should be <strong id="openMsg">OPEN</strong>
//       <InfoTag id="openJobMsgForApplicant" lng={this.props.i18n.language}/> or <strong id="boundedMsg">BOUNDED</strong>
//       <InfoTag id="boundedJobMsgForApplicant" lng={this.props.i18n.language}/> to only this Job.
//     </p>
//   );
// }

//#endregion

//#region JOBS
export function getJobsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Delovna mesta se delijo na <b>ODPRTA</b> in <b>VEZANA</b>.
      </div>
    );
  } else {
    return (
      <div>
        Jobs are divided by two types: <b>OPEN</b> and <b>BOUNDED</b>.
      </div>
    );
  }
}

export function getJobsURLText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Preko te povezave se lahko kandidati prijavljajo na delovno mesto. Kandidatom lahko povezavo pošljete ali pa jo
        uporabite v drugih zaposlitvenih portalih.
      </div>
    );
  } else {
    return (
      <div>
        This URL can be used to start Application process for this job. You can send it to Applicants or add it to
        "Apply" buttons to job portals.
      </div>
    );
  }
}

export function getCopyToClipboardText(lng) {
  if (lng === 'si') {
    return <div>Kopiraj povezavo.</div>;
  } else {
    return <div>Copy Link to Clipboard.</div>;
  }
}

export function getJobsMustBePublishedInfo(lng) {
  if (lng === 'si') {
    return (
      <div>
        Delovno mesto mora biti v statusu <b>Objavljen</b>, da se lahko kandidati prijavijo.
      </div>
    );
  } else {
    return (
      <div>
        Job must have status <b>Published</b> to start receiving Applications.
      </div>
    );
  }
}

export function getOpenJobsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>ODPRTA:</b> sprejemajo tudi prijavnice kandidatov, ki se prijavljajo na podobna delovna mesta (prijavnice
        samodejno zgenerira program).
      </div>
    );
  } else {
    return (
      <div>
        <b>Open:</b> accepts also Applicants which are applying to similar Jobs (applications are generated
        automatically by the system.).
      </div>
    );
  }
}
export function getBoundedJobsText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Na <b>VEZAN</b> tip delovnih mest se kandidati lahko prijavljajo samo neposredno.
      </div>
    );
  } else {
    return (
      <div>
        <b>Bounded:</b> Applicants must send Application directly to this Job for processing.
      </div>
    );
  }
}

export function getJobsTitleText(lng) {
  if (lng === 'si') {
    return <div>Delovna mesta se delijo na dva tipa</div>;
  } else {
    return <div>There are two types of Jobs</div>;
  }
}

export function getJobsScoreText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Izračunano iz uteži kompetenc in kandidatovih lastih ocen znanja za podane kompetence. <b>POZOR: </b>
        če delovno mesto nima dodanih kompetenc, izračun in rangiranje kandidatov ni mogoče.
      </div>
    );
  } else {
    return (
      <div>
        Calculated from Competence weights and Applicant skill estimations. <b>NOTE: </b>
        if Job has no Competences defined, the score is not calculated.
      </div>
    );
  }
}

export function getJobsExpirationDate(lng) {
  if (lng === 'si') {
    return (
      <div>
        Datum, do katerega se bodo kandidati lahko prijavljali na to delovno mesto. Ta datum lahko v prihodnosti
        spremenite.
      </div>
    );
  } else {
    return (
      <div>Date untill this job will receive applicants. You can prolong this date in the future by editing job.</div>
    );
  }
}

export function getMaxPossibleScoreText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Največja možna vsota, glede na kompetence in njihove uteži. Ob vsaki spremembi na kompetencah, se Največja možno
        vsota ponovno preračuna.
      </div>
    );
  } else {
    return (
      <div>
        Sum of all Job competences combined with their weights. Gets recalculated every time when Competence is added or
        removed from the Job.
      </div>
    );
  }
}

export function getOpenJobMsgForApplicant(lng) {
  if (lng === 'si') {
    return (
      <div>
        Sistem bo samodejno poiskal tudi druga, za vas najbolj primerna delovna mesta glede na kompetence. Izbranim
        podjetjem bo poslan tudi vaš življenjepis.
      </div>
    );
  } else {
    return (
      <div>
        The system will automatically search for other jobs, which are most relevant for you. Also, your CV will be sent
        to the selected companies.
      </div>
    );
  }
}

export function getBoundedJobMsgForApplicant(lng) {
  if (lng === 'si') {
    return <div>Delodajalci s podobnimi delovnimi mesti vas ne bodo mogli kontaktirati.</div>;
  } else {
    return <div>You will be hidden from other recruters/companies.</div>;
  }
}

export function getJobsQuestion1(lng) {
  if (lng === 'si') {
    return <span>Ustvaril sem novo delovno mesto. Kako naprej?</span>;
  } else {
    return <span>I created my first Job. Now what?</span>;
  }
}

export function getJobsAnswer1(lng) {
  if (lng === 'si') {
    return (
      <p>
        Ko ustvarite delovno mesto, mu spremenite status v <b>Objavljen</b>. Sistem bo generiral povezavo, preko katere
        se lahko kandidatje prijavljajo. To povezavo lahko pošljete kandidatom preko spleta ali pa jo uporabite na
        drugih zaposlitvenih portalih za postopek prijave kandidatov. Delovno mesto bo s tem objavljeno tudi na
        Zaposlitvenem portalu.
      </p>
    );
  } else {
    return (
      <p>
        When a Job is created, make sure that you publish it. When Job is published, a link for Application creation
        will be generated. You can send this link to Applicants or you can use it on other Job portals for starting
        Application proccess. The Job will also become visible on the Job Portal.
      </p>
    );
  }
}

export function getJobsQuestion2(lng) {
  if (lng === 'si') {
    return (
      <span>
        Delovna mesta se nahajajo v različnih statusih. Ali lahko spremenim status <b>Arhiviran</b> nazaj v{' '}
        <b>Objavljen</b>?
      </span>
    );
  } else {
    return (
      <span>
        There are different Job Statuses. Can I change status from <b>Archived</b> back to <b>Published</b>?
      </span>
    );
  }
}

export function getJobsAnswer2(lng) {
  if (lng === 'si') {
    return <p>Da. Status lahko spremenite nazaj, na delovno mesto se bodo zopet lahko prijavljali kandidti.</p>;
  } else {
    return <p>Yes. You can change it back and Job will be able to receive Applicants again.</p>;
  }
}

/* Job Statuses */
export function getPublishedJobStatusText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Kandidati se lahko prijavljajo. Delovno mesto je tudi objavljeno na našem <b>Zaposlitvenem portalu</b>
      </div>
    );
  } else {
    return (
      <div>
        Applicants can apply to this Job. Job is also visible on our <b>Job Web Portal</b>.
      </div>
    );
  }
}

export function getDraftJobStatusText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Delovno mesto je v začetnem statusu (<b>V pripravi</b>). Ko končate z opisom delovnega mesta, spremenite status
        v "<b>Objavljen</b>", da bo lahko začelo sprejemati prijave kandidatov.
      </div>
    );
  } else {
    return (
      <div>
        Job is in its initial state (Draft). You can <b>publish</b> it to start receiving Applications or
        <b> archive</b> it to set it to inactive state.
      </div>
    );
  }
}

export function getArchivedJobStatusText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Kandidati se ne morejo prijavljati na to delovno mesto. Delovno je tudi umaknjeno z našega{' '}
        <b>Zaposlitvenega portala</b>
      </div>
    );
  } else {
    return (
      <div>
        Applicants can no longer apply to this Job. It is not visible on our <b>Job Web Portal</b>.
      </div>
    );
  }
}

export function getClosedJobStatusText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Delovno mesto ni več objavljeno na našem <b>Zaposlitvenem portalu</b>, kandidati se lahko še vedno prijavljajo
        preko povezave za prijavo. Status delovnega mesta lahko kadarkoli spremenite.
      </div>
    );
  } else {
    return (
      <div>
        Job is no longer visible on on our <b>Job Web Portal</b>, but Applicants can still apply. You can{' '}
        <b>Publish job again or Archive it</b> to put it in Inactive state.
      </div>
    );
  }
}

export function getExpiredJobStatusText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Delovno mesto ni več objavljeno na našem <b>Zaposlitvenem portalu</b>, kandidati se lahko še vedno prijavljajo
        preko povezave za prijavo. Status delovnega mesta lahko kadarkoli spremenite.
      </div>
    );
  } else {
    return (
      <div>
        Job is no longer visible on on our <b>Job Web Portal</b>, but Applicants can still apply. You can{' '}
        <b>change the Expiration date in the Job Settings</b>{' '}
      </div>
    );
  }
}

export function getNoSuitableJobsMsg(lng) {
  if (lng === 'si') {
    return (
      <b>
        Glede na vaše podane kompetence, trenutno nismo našli delovnih mest s podobnimmi kompetencami.
        <br />
        Ko se pojavijo primerna delovna mesta, vas bomo obvestili.
      </b>
    );
  } else {
    return (
      <b>
        Based on provided Competences and Experiences, we could not find any other suitable jobs at the moment.
        <br />
        We will keep you informed about other suitable Jobs, when they get published.
      </b>
    );
  }
}
//#endregion

//#region COMPETENCES
export function getCompetencesText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <ul>
          <li>
            <b>OBIČAJNE:</b> možne vrednosti od 1 do 10.
          </li>
          <li>
            <b>OPCIJSKE:</b> možne vrednosti: Da ali Ne.
          </li>
          <li>{GetInverseCompetenceLocalSi()}</li>
        </ul>
      </div>
    );
  } else {
    return (
      <div>
        <ul>
          <li>
            <b>Normal:</b> possible values from 1 to 10.
          </li>
          <li>
            <b>Boolean:</b> possible values: True or False.
          </li>
          <li>{GetInverseCompetenceLocalEn()}</li>
        </ul>
      </div>
    );
  }
}

export function GetInverseCompetenceLocalEn() {
  return (
    <div>
      <b>Inverse:</b> possible values from 1 to 10. Used for testing how honest Candidates are with their answers. Use
      this type for competences which do not exist in reality. The higher score that the candidate will give
      himself/herself, less honest he/she is.
    </div>
  );
}

export function addStrongestCompetencesText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>
          Vnesite svoje najmočnejše kompetence in jih opišite. Z njihovo pomočjo bomo iskali najbolj primerna delovna
          mesta za vas in vas o obveščali o njih.
        </b>
      </div>
    );
  } else {
    return (
      <div>
        <b>
          Add your strongest Competences and rate your experiences. This will help us to find most suitable Jobs from
          database and also from all the Jobs that will be added in the future.
        </b>
      </div>
    );
  }
}
export function addStrongestCompetencesText2(lng) {
  if (lng === 'si') {
    return (
      <div>
        Opcijsko: opišete lahko, kako ste pridobili kompetence in izkušnje. Dodate lahko povezave do vaših projektov
        itd...{' '}
      </div>
    );
  } else {
    return (
      <div>
        Optional: You can also describe how did you gain experiences regarded to competences (with links, project
        descriptions that you worked on, etc.).{' '}
      </div>
    );
  }
}

export function describeHowYouGotCompetences(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>Opcijsko:</b> opišete lahko, kako ste pridobili kompetence in izkušnje. Dodate lahko povezave do vaših
        projektov itd...{' '}
      </div>
    );
  } else {
    return (
      <div>
        <b>Optional:</b> describe how did you obtain experiences. You can all add links to your projects related with
        the competence, etc...
      </div>
    );
  }
}

// export function getNoCompetencesForJob(lng) {
//   if (lng === 'si') {
//     return (
//       <strong>
//         Delovno mesto nima kompetenc, zato seštevek točk ni mogoč.
//         <br />
//         Proiporočamo, da dodate kompetence delovnemu mestu za analizo točk.
//       </strong>
//     );
//   } else {
//     return (
//       <strong>
//         There are no Competences added to the Job, therefore no analysis can be made. <br />
//         We recommend that you can add Competences to the Job.
//       </strong>
//     );
//   }
// }

export function getCompetencesTitleText(lng) {
  if (lng === 'si') {
    return <div>Obstajajo trije različni tipi kompetenc</div>;
  } else {
    return <div>There are three types of Competences</div>;
  }
}

export function getNormalCompetencesText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>OBIČAJNE:</b> možne vrednosti od 1 do 10. Primer: poznavanje programa Excel.
      </div>
    );
  } else {
    return (
      <div>
        <b>Normal:</b> possible values from 1 to 10. Example: knowledge of Excel program.
      </div>
    );
  }
}

export function getBoolenCompetencesText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>OPCIJSKE:</b> uporabne za kompetence, kjer je možna vrednos: <b>Da</b> ali <b>Ne</b>. Primer: vozniški izpit
        kategorije B1.
      </div>
    );
  } else {
    return (
      <div>
        <b>Boolean:</b> used for competences which can be assigned only values: <b>True</b> or <b>False</b>. Example:
        driving license.
      </div>
    );
  }
}

export function getInverseCompetencesText(lng) {
  if (lng === 'si') {
    return GetInverseCompetenceLocalSi();
  } else {
    return GetInverseCompetenceLocalEn();
  }
}

export function GetInverseCompetenceLocalSi() {
  return (
    <div>
      <b>INVERZNE:</b> možne vrednosti od 1 do 10. Te točke se od skupnega seštevka točk <b>odštejejo</b>. Uporabite ta
      tip za kompetence, ki v resnici ne obstajajo. Z njimi ugotovite koliko so kandidati iskreni pri odgovorih.
    </div>
  );
}

export function getCompetencesDescriptionText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <p>
          Kompetence uporabljamo za opis znanj oz. sposobnosti, katere so potrebne, da uspešno opravljamo delo. Pomembne
          so pri opisu zahtev delovnega mesta. Več kompetenc kot dodate delovnemo mestu, bolj natančno bo program iskal
          primerne kandidate.
        </p>
        <p>
          Kompetencam je potrebno dodati tudi <b>uteži</b>. Uteži (vrednosti lahko imajo od 1 do 10) določajo kako
          pomembna je določena kompetenca za delovno mesto.
        </p>
      </div>
    );
  } else {
    return (
      <div>
        <p>
          Competences are used to describe skills and/or abilities which are necessary to perform a Job successfully.
          They are important for describing Job requirements for the Applicants. The more Competences you add to a Job
          the more precise will algorithms be when searching for most suitable Applicants.
        </p>
        <p>
          When adding a Competence to a Job, you must also assign <b>weight</b> to it. This will indicate how important
          that Competence is for the given Job.
        </p>
      </div>
    );
  }
}

export function getInstructionsForCompetencesText(maxAllovedCompetences, lng) {
  if (lng === 'si') {
    return (
      <div>
        Kompetence in vprašanja se samodejno postavijo kandidatu, ko se prijavlja na delovno mesto.
        <br />
        Vsakemu delovnemu mestu lahko dodate do {maxAllovedCompetences} kompetenc.
      </div>
    );
  } else {
    return (
      <div>
        Competences & Questionas are automatically given to the applicant when he/she is applying for the job. Add up to{' '}
        {maxAllovedCompetences} Competences.
      </div>
    );
  }
}

export function getInstructionsForQuestionnaire(lng) {
  if (lng === 'si') {
    return <div>Rekruter začne izvajati vprašalnik, ko želi govoriti s kandidatom.</div>;
  } else {
    return <div>Questionnaire is manually triggered by the recruiter when he/she wants to talk to the applicant.</div>;
  }
}

export function getNegativeScorePartText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Seštevek točk vseh kompetenc tipa <b>INVERZNE</b>.
      </div>
    );
  } else {
    return (
      <div>
        Score, which is the sum from <b>Inverse</b> Competences.
      </div>
    );
  }
}

export function getRecruitersEmailDescription(lng) {
  if (lng === 'si') {
    return (
      <div>
        Na ta email boste dobivali vsa obvestila s portala. Ta email ne vpliva na email naslov, ki se uporablja za
        uporabniško ime.
      </div>
    );
  } else {
    return <div>You will get all notifications to this email address. This does not affect your username address.</div>;
  }
}

export function getPositiveScorePartText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Seštevek točk vseh kompetenc tipa <b>OBIČAJNE</b>.
      </div>
    );
  } else {
    return (
      <div>
        Score, which is the sum from <b>Normal</b> Competences.
      </div>
    );
  }
}

export function getWeightDescriptionText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Določa pomembnost kompetence za delovno mesto. Uteži z višjimi vrednostmi imajo večji vpliv na končno število
        točk posameznega kandidata. Možne vrednosti uteži: od 1 do 10.
      </div>
    );
  } else {
    return (
      <div>
        Defines the importance of a competence. Higher weight will have a bigger impact on the final Applicant's score.
      </div>
    );
  }
}

export function getCompetencesQuestion1(lng) {
  if (lng === 'si') {
    return (
      <span>
        Je k delovnemu mestu priporočljivo dodati <b>kompetence</b>? Zakaj?
      </span>
    );
  } else {
    return (
      <span>
        Should I add <b>Competences</b> to the Job and why?
      </span>
    );
  }
}

export function getCompetencesAnswer1(lng) {
  if (lng === 'si') {
    return (
      <div>
        <p>
          Da. Dodajanje kompetenc k službi močno priporočamo. Preko njih bo sistem točkoval in rangiral vse prijavljene
          kandidate. Preko njih lahko iščete najbolj primerne kandidate za specifično službo in tudi obratno: najbolj
          primerne službe za posameznega kandidata.
        </p>
        <p>
          Iz dodanih kompetenc bo sistem tudi sestavil vprašalnik, preko katerega bo vodil vsakega kandidata, ko se le
          ta prijavlja na delovno mesto.
        </p>
      </div>
    );
  } else {
    return (
      <div>
        <p>
          Yes. We strongly recommend that you add Competences to the Job, because this will enable the system to search
          for most suitable Applicants for a given Job. It will also enable to search for most suitable Jobs for a
          specific Applicant.{' '}
        </p>
        <p>
          The system will automatically guide Applicants through a Questionnaire composed from the Competences and at
          the end rank each Applicant. This will not be possible if you do not add Competences to Jobs.
        </p>
      </div>
    );
  }
}

export function getCompetencesQuestion2(lng) {
  if (lng === 'si') {
    return <span>Željene kompetence ne najdem v bazi. Lahko sam dodajam nove v bazo?</span>;
  } else {
    return <span>I can not find the Competence that I want to add. Can I insert my own Competences?</span>;
  }
}

export function getCompetencesAnswer2(lng) {
  if (lng === 'si') {
    return (
      <div>
        Da. Nove kompetence lahko dodajate:{' '}
        <b>
          <i>Meni -> Kompetence</i>
        </b>{' '}
        ali iz{' '}
        <b>
          <i>Okna za urejanje kompetenc</i>
        </b>
      </div>
    );
  } else {
    return (
      <div>
        Yes. You can add new (missing) competences from{' '}
        <b>
          <i>Menu -> Competences</i>
        </b>{' '}
        or from{' '}
        <b>
          <i>Competence Management</i>
        </b>{' '}
        window.
      </div>
    );
  }
}

export function getCompetencesQuestion3(lng) {
  if (lng === 'si') {
    return <span>Uteži na kompencah? Zakaj so pomembne?</span>;
  } else {
    return <span>Weights? Why are they important?</span>;
  }
}

export function getCompetencesAnswer3(lng) {
  if (lng === 'si') {
    return (
      <div>
        Z utežmi določimo kako pomembna je kompetenca za določeno delovno mesto. Uteži imajo tudi pomemben vpliv na
        točkovanje in rangiranje kandidatov, ko se ti prijavljajo na delovna mesta.
      </div>
    );
  } else {
    return (
      <div>
        With Weights you determine how important the Competence is for the specific Job. This will have impact on
        ranking and scoring Applicants when they apply for the Job.
      </div>
    );
  }
}
//#endregion

//#region COMMENTS
export function getCommentsShortcutText(lng) {
  if (lng === 'si') {
    return <div>Bližnjica do zadnjih komentarjev.</div>;
  } else {
    return <div>Shortcut to latest Comments.</div>;
  }
}
//#endregion

//#region CALENDAR
export function getCalendarDescriptionText(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h3>
          <small>S koledarjem si lahko urejamo sestanke in vse druge dogodke, ki so vezani na datum in čas.</small>
        </h3>
        <h4>Glavne funkcionalnosti:</h4>
        <ul>
          <li>S klikom v koledar (v določen čas in datum) ustvarimo nov dogodek.</li>
          <li>Ustvarjeni dogodek lahko premikamo po koledarji in mu s tem spreminjamo čas in datum.</li>
        </ul>
      </div>
    );
  } else {
    return (
      <div>
        <h3>
          <small>With Calendar you can manage your meetings and other stuff</small>
        </h3>
        <h4>Main functionalities:</h4>
        <ul>
          <li>Create new Calendar event by clicking on the desired time frame in the Calendar.</li>
          <li>Drag & Drop Calendar event to change start/end of the event.</li>
        </ul>
      </div>
    );
  }
}
//#endregion

//#region WALKTHROUGH
export function getReactour__company(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>1: Uporabniške nastavitve & Nastavitve podjetja</b>
        </h4>
        Priporočamo, da najprej izpolnite podatke o uporabniškem računu in o vašem podjetju.
        <br />
        <br />
        Ko se bodo kandidati prijavljeli na delovna mesta, jim bodo nekateri podatki (ime podjetja, lokacija, ...)
        prikazani samodejno.
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>1: User & Company Settings</b>
        </h4>
        Start by clicking in the highlighted square, to fill in your personal and company Settings. <br />
        <br />
        This will allow Job Applicants to see your contact info, company logotype etc...
      </div>
    );
  }
}

export function getReactour__jobs(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>2: Upravljanje z delovnimi mesti</b>
        </h4>
        Zatem, ko izpolnete informacije o podjetju, lahko pričnete z ustvarjanjem delovnih mest.
        <br />
        <br />
        Ko ustvarite prvo delovno mesto in mu postavite status v <b>"Objavljen"</b>, se kandidati lahko začnejo
        prijavljati.
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>2: Managing Jobs</b>
        </h4>
        After completing with Step 1, you can start creating Job definitions/advertisements.
        <br />
        <br />
        When first Job is created, Job applicants/candidates can start to apply.
        <br />
        You can manage Jobs by clicking on the highlighted square or in the Menu on the left.
      </div>
    );
  }
}

export function getReactour__job_info(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <em className="fa mr-2 fas fa fa-question-circle"></em>
          <b>Več informacij</b>
        </h4>
        S klikom na ikono &nbsp;&nbsp;<em className="fa mr-2 fas fa fa-question-circle"></em>
        izveste več informacij o določenih pojmih.
        <br />
        <br />
        Ta ikona se vedno nahaja blizu točk, ki potrebujejo podrobnejšo obrazložitev.
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <em className="fa mr-2 fas fa fa-question-circle"></em>
          <b>More info icon</b>
        </h4>
        You can click on &nbsp;&nbsp;<em className="fa mr-2 fas fa fa-question-circle"></em> to see more details about
        any item.
        <br />
        <br />
        This icon will always be near when you need more information.
      </div>
    );
  }
}

export function getReactour__applicants(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>3: Upravljanje s kandidati</b>
        </h4>
        Tukaj lahko dostopate do kandidatov.
        <br />
        <ul>
          <li>Profili kandidatov se ustvarijo samodejno, ko se kandidati prijavljajo na delovna mesta.</li>
        </ul>
        <ul>
          <li>
            Kandidate lahko vnesete tudi ročno, s klikom <b>"Vnesi kandidata"</b>, v levem menuju.
          </li>
        </ul>
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>3: Managing Applicants</b>
        </h4>
        Applicants can be accessed here.
        <br />
        <ul>
          <li>Applicants are created automatically when they apply for a Job</li>
        </ul>
        <ul>
          <li>Applicants can be created manually.</li>
        </ul>
      </div>
    );
  }
}

export function getReactour__create_applicant(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>Vnašanje/kreiranje novih kandidatov</b>
        </h4>
        <br />
        Kandidate lahko ustvarjamo tudi ročno (s pomočjo čarovnika).
        <br />
        Po končanem vnosu, bo sistem samodejno poiskal najbolj primerna delovna mesta za vnešenega kandidata.
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>Create Applicant manually</b>
        </h4>
        <br />
        Applicants can be inserted/created manually here (with wizard).
        <br />
        At the end of the process, the system will automatically search for most suitable Jobs for the created
        Applicant.
      </div>
    );
  }
}

export function getReactour__applications(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>4: Upravljanje s prijavnicami</b>
        </h4>
        <br />
        Tukaj lahko dostopate do prijavnic.
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>Step 4: Managing Applications</b>
        </h4>
        <br />
        Applications can be accessed here.
      </div>
    );
  }
}

export function getReactour__comments(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>5: Center opravil</b>
        </h4>
        <br />
        Seznam aktualnih novosti in bližnjice do njih.
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>Step 5: Action Center</b>
        </h4>
        <br />A list of important items for today with shortcuts.
      </div>
    );
  }
}

export function getReactour__calendar(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>6: Koledarček dogodkov</b>
        </h4>
        <br />
        Tukaj lahko vnašate opomnike za sestanke, telefonske klice...
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>Step 6: Calendar Events</b>
        </h4>
        <br />
        Add your meetings, reminders and other date related stuff here.
      </div>
    );
  }
}

export function getReactour__competences(lng) {
  if (lng === 'si') {
    return (
      <div>
        <h4>
          <b>7: Kompetence</b>
        </h4>
        <br />
        Kompetence so pomembne za opisovanje delovnih mest. S pomočjo podanih kompetenc, bo sistem samodejno sestavil
        vprašalnik za vsakega kandidata, ko se bo ta prijavljal na delovno mesto.
        <br />
        Tukaj lahko dodajate in urejate kompetence. *Kompetence, ki so že dodani k delovnem mestu, ne morete urejati.
      </div>
    );
  } else {
    return (
      <div>
        <h4>
          <b>Step 7: Competences</b>
        </h4>
        <br />
        Competences are important for describing Job requirements for the Applicants. With provided competences, the
        system will compose a questionnaire for each Applicant when he/she applies for a Job.
        <br />
        You can view, modify or add new Competences here. *Competences which are already added to a Job, can not be
        modified.
      </div>
    );
  }
}

export function getReactour__walkthrough(lng) {
  if (lng === 'si') {
    return (
      <div>
        <b>Vodič</b>
        <br />
        Ta vodič lahko odprete tukaj kadarkoli!
      </div>
    );
  } else {
    return (
      <div>
        <b>Walkthrough</b>
        <br />
        You can always access this walkthrough here!
      </div>
    );
  }
}
//#endregion

export function getEmailRecoveryText(lng) {
  if (lng === 'si') {
    return (
      <div>
        Na vaš email naslov smo vam poslali možnost za ponastavitev gesla.{' '}
        <b>(če ste vnesli pravilen email naslov in če je vaš naslov že bil potrjen ob aktivaciji)</b>. <br />
        <p> </p>
        <p>
          Za ponastavitev gesla, odprite vaš email naslov in preverite sporočila. Pošiljanje sporočila lahko traja nekaj
          minut.
        </p>
      </div>
    );
  } else {
    return (
      <div>
        Email for password reset has been sent to your Email account{' '}
        <b>(IF provided email is correct and IF it was successfully confirmed at account activation)</b>. <br />
        <p> </p>
        <p>Please go to your Email account to reset your password. Email sending can take a couple of minutes.</p>
      </div>
    );
  }
}

export default HelpMessages;
